interface Props {
  className?: string;
}

export default function HalfStarIcon({className}: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18">
      <path
        fillRule="nonzero"
        d="m9 0 2.781 5.925 6.219.95-4.5 4.613L14.562 18 9 14.925 3.438 18 4.5 11.488 0 6.875l6.219-.95L9 0Zm0 3.46v9.736l3.629 2.006-.693-4.249 2.935-3.009-4.057-.62L9 3.46Z"
      />
    </svg>
  );
}
